module.exports = __webpack_public_path__ + "img/logo.6116810a.png";